import { Col, List, Row, Tooltip, Typography } from "antd";
import { get } from "lodash";
import React from "react";
var ResponsiveView = function (_a) {
    var data = _a.data, responsive = _a.responsive, columns = _a.columns;
    var content = responsive.content;
    if (typeof content !== "function") {
        var contentColumns = content;
        return (React.createElement(List, { header: responsive.header && responsive.header(data), footer: responsive.footer && responsive.footer(data) }, contentColumns.map(function (column) {
            var itemView;
            var itemColumn = columns.find(function (columnKey) { return columnKey.key === column; });
            if (itemColumn) {
                var itemColumnsValue = get(data, itemColumn.dataIndex, "N/A");
                if (itemColumn.render) {
                    itemView = itemColumn.render(itemColumnsValue, data, 0);
                }
                else {
                    itemView =
                        React.createElement(Tooltip, { placement: "bottom", style: { fontSize: "10px" }, title: itemColumnsValue }, itemColumnsValue);
                }
                return (React.createElement(List.Item, null,
                    React.createElement(Row, { gutter: 8, style: { width: "100%" } },
                        React.createElement(Col, { span: 16 },
                            React.createElement(Typography.Paragraph, { ellipsis: true, className: "no-margin" }, itemView)),
                        React.createElement(Col, { span: 8, className: "align-right" },
                            React.createElement(Typography.Paragraph, { ellipsis: true, type: "secondary", className: "no-margin" }, itemColumn.title)))));
            }
            return null;
        })));
    }
    else {
        return React.createElement(React.Fragment, null, content(data));
    }
};
export default ResponsiveView;
//# sourceMappingURL=responsive-view.js.map